
export default {
  name: 'CardsLoader'
}
